import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {AuthStore} from '../store/auth.store';

export const roleGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const user = authStore.user();

  if (!user) {
    // User is not logged in at all
    window.location.assign(environment.authUrl);
    return false;
  }

  // Get the roles required for this route from the route data
  // Default to requiring 'agent' if no specific roles are defined
  const requiredRoles = (route.data?.['roles'] as Array<string>) || [
    'agent',
    'newspaper',
    'institution',
  ];

  // Check if the user has any of the required roles
  // We check user.role or fallback to checking user.user_type
  const hasRole = requiredRoles.includes(user.role) || requiredRoles.includes(user.user_type);

  if (hasRole) {
    return true;
  }

  // User is logged in but lacks the required role for this route. If they
  // belong to this app at all (agent/newspaper/institution) but hit a route
  // reserved for a different one of those roles, send them back to their own
  // dashboard -- it carries no role restriction of its own, so this is safe.
  const belongsToThisApp = ['agent', 'newspaper', 'institution'].some(
    (r) => user.role === r || user.user_type === r
  );

  if (belongsToThisApp) {
    router.navigate(['/partner/dashboard']);
    return false;
  }

  // User has no role in this app (e.g. an admin or individual applicant).
  // Redirect them to auth without logging out; auth's guestGuard will route
  // them to their designated portal.
  window.location.assign(environment.authUrl);
  return false;
};
